import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { formatSaMobile } from '../../../shared/utils/sa-phone';

export interface IdDocumentPreviewDialogData {
  userEmail: string | null;
  phone?: string | null;
  industry?: 'REAL_ESTATE_PROFESSIONAL' | 'LEGAL_PROFESSIONAL' | 'OTHER' | null;
  industryOther?: string | null;
  ffcDocumentPath?: string | null;
  ffcSignedUrl?: string | null;
  ffcExpiresAt?: string | null;
  idDocumentPath: string | null;
  signedUrl: string | null;
  expiresAt: string | null;
}

@Component({
  selector: 'app-id-document-preview-dialog',
  templateUrl: './id-document-preview-dialog.component.html',
})
export class IdDocumentPreviewDialogComponent {
  readonly idSignedUrl: string | null;
  readonly idSafeSignedUrl: SafeResourceUrl | null;
  readonly isIdImagePreview: boolean;
  readonly ffcSignedUrl: string | null;
  readonly ffcSafeSignedUrl: SafeResourceUrl | null;
  readonly isFfcImagePreview: boolean;
  readonly industryLabel: string;
  readonly phoneLabel: string;

  constructor(
    private readonly dialogRef: MatDialogRef<IdDocumentPreviewDialogComponent>,
    private readonly sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public readonly data: IdDocumentPreviewDialogData
  ) {
    this.idSignedUrl = (data.signedUrl || '').trim() || null;
    this.idSafeSignedUrl = this.idSignedUrl
      ? this.sanitizer.bypassSecurityTrustResourceUrl(this.idSignedUrl)
      : null;
    const idPreviewSource = `${data.idDocumentPath || ''} ${this.idSignedUrl || ''}`.toLowerCase();
    this.isIdImagePreview = /\.(png|jpe?g|webp|gif|bmp|heic|heif)(\?|#|$)/i.test(idPreviewSource);

    this.ffcSignedUrl = (data.ffcSignedUrl || '').trim() || null;
    this.ffcSafeSignedUrl = this.ffcSignedUrl
      ? this.sanitizer.bypassSecurityTrustResourceUrl(this.ffcSignedUrl)
      : null;
    const ffcPreviewSource = `${data.ffcDocumentPath || ''} ${this.ffcSignedUrl || ''}`.toLowerCase();
    this.isFfcImagePreview = /\.(png|jpe?g|webp|gif|bmp|heic|heif)(\?|#|$)/i.test(ffcPreviewSource);

    this.industryLabel = this.resolveIndustryLabel(data.industry, data.industryOther);
    const formattedPhone = formatSaMobile(data.phone);
    this.phoneLabel = formattedPhone || 'Not provided';
  }

  private resolveIndustryLabel(
    industry: 'REAL_ESTATE_PROFESSIONAL' | 'LEGAL_PROFESSIONAL' | 'OTHER' | null | undefined,
    industryOther: string | null | undefined
  ): string {
    if (industry === 'REAL_ESTATE_PROFESSIONAL') return 'Real Estate Professional';
    if (industry === 'LEGAL_PROFESSIONAL') return 'Legal Professional';
    if (industry === 'OTHER') {
      const detail = String(industryOther || '').trim();
      return detail ? `Other - ${detail}` : 'Other';
    }
    return 'Not provided';
  }

  close(): void {
    this.dialogRef.close();
  }
}
